module.exports = __webpack_public_path__ + "static/media/Db4.5402ceab.mp3";